<div class="row page">
    <div class="col-lg-12">
        <h1 class="page-header">Support</h1>
    </div>
</div>
